<template>
    <div class="module-factor">
        <v-layout align-center justify-start>
            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/factor_1.png">
            <span class="factor factor1">
                <span v-for="i in 3" class="effect" :class="`effect${i}`"></span>
                {{ $userData.factor1 }}
            </span>
            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/factor_2.png">
            <span class="factor factor2">
                <span v-for="i in 3" class="effect" :class="`effect${i}`"></span>
                {{ $userData.factor2 }}
            </span>
            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/factor_3.png">
            <span class="factor factor3">
                <span v-for="i in 3" class="effect" :class="`effect${i}`"></span>
                {{ $userData.factor3 }}
            </span>
            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/factor_4.png">
            <span class="factor factor4">
                <span v-for="i in 3" class="effect" :class="`effect${i}`"></span>
                {{ $userData.factor4 }}
            </span>
        </v-layout>
    </div>
</template>

<script>
    export default {
        watch: {
            '$userData.factor1': {
                handler(val, oldVal) {
                    this.onChange('factor1', val - oldVal)
                }
            },
            '$userData.factor2': {
                handler(val, oldVal) {
                    this.onChange('factor2', val - oldVal)
                }
            },
            '$userData.factor3': {
                handler(val, oldVal) {
                    this.onChange('factor3', val - oldVal)
                }
            },
            '$userData.factor4': {
                handler(val, oldVal) {
                    this.onChange('factor4', val - oldVal)
                }
            },
        },

        mounted() {
        },

        methods: {
            onChange(id, amount) {
                const className = amount > 0 ? 'plus' : 'minus'
                const translate = amount > 0 ? -40 : 40
                const text = amount > 0 ? `+${amount}` : `${amount}`

                setTimeout(_ => {
                    this.$playAudio(9)
                }, 200)

                for (let i = 1; i <= 3; i++) {
                    setTimeout(_ => {
                        $(`.${id} .effect${i}`)
                            .text(text)
                            .show()
                            .addClass(className)
                            .animate({
                                opacity: 0,
                                top: translate
                            }, 700, _ => {
                                $(`.${id} .effect${i}`)
                                    .css('opacity', 1)
                                    .css('top', '')
                                    .removeClass('plus')
                                    .removeClass('minus')
                                    .hide()
                            })
                    }, i * 200 - 100)
                }

                // setTimeout(_ => {
                //     $('.effect').removeClass('run').removeClass('plus').removeClass('minus').hide()
                // }, 1000)

            },
        }
    }
</script>

<style lang="scss" scoped>
    .module-factor{
        width: 378px;
        height: 32px;
        margin-top: 16.3px;
        margin-left: 25.1px;
        display: inline-block;

        .factor {
            font-size: 21px;
            font-family: "5x5 Pixel", sans-serif;
            color: #ffffff;
            margin-left: 7.3px;
            margin-right: 11px;
            min-width: 45px;
            text-shadow: 2px 2px rgba(27, 30, 33, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

        }

        .effect {
            position: absolute;
            display: none;
            font-family: '5x5 Pixel', sans-serif;
            font-size: 21px;
        }

        .effect.plus {
            color: #00ff27;
            top: -15px;
        }
        .effect.minus {
            color: #fc1818;
            top: 15px;
        }
    }
</style>

<style>

</style>
